import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemLabelName, FormItemName, FormItemType } from '@framework/workbench/drawer/constants';
import { fontStyle } from '../../text/text-box/config';
import i18n from '@i18next/i18n';

export const PositionSpinOptions = {
    suffix: i18n.t('厘米'),
    step: 0.1,
    allowDecimal: true,
    toFixed: 2,
    max: 100,
    min: -100,
};

export const SizeSpinOptions = {
    suffix: i18n.t('厘米'),
    step: 0.1,
    allowDecimal: true,
    toFixed: 2,
    max: 50,
    min: 0,
};

const SpinStyle = {
    fontSize: '12px',
};

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.PICTURE_TAILOR,
        content: '',
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.PICTURE_POSITION_TEXT,
        value: FormItemLabelName.PICTURE_POSITION,
        style: fontStyle,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.PICTURE_POSITIOIN_WIDTH,
        label: FormItemLabelName.WIDTH,
        options: SizeSpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.PICTURE_POSITIOIN_HEIGHT,
        label: FormItemLabelName.HEIGHT,
        options: SizeSpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.PICTURE_POSITIOIN_OFFSET_X,
        label: FormItemLabelName.OFFSET_X,
        options: PositionSpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.PICTURE_POSITIOIN_OFFSET_Y,
        label: FormItemLabelName.OFFSET_Y,
        options: PositionSpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.CROP_POSITION_TEXT,
        value: FormItemLabelName.CROP_POSITION,
        style: fontStyle,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.CROP_POSITIOIN_WIDTH,
        label: FormItemLabelName.WIDTH,
        options: SizeSpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.CROP_POSITIOIN_HEIGHT,
        label: FormItemLabelName.HEIGHT,
        options: SizeSpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.CROP_POSITIOIN_LEFT,
        label: FormItemLabelName.LEFT,
        options: PositionSpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.CROP_POSITIOIN_TOP,
        label: FormItemLabelName.TOP,
        options: PositionSpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
];
